import React from "react";
const NeoAnalytics: React.FC = () => <></>;
export default NeoAnalytics;
